import { getApiV1UsersUserIdPermissions } from '@/open-api/users/users';

import type { Permission, Role } from '@/types/auth';

export interface UserRolesAndPermissionsResponse {
  permissions: Permission[] | Permission;
  role: Role[] | Role;
}

/**
 * Fetches the user's roles and permissions.
 */
export const fetchUserRolesAndPermissions = async (
  userId: string | number | null | undefined
): Promise<UserRolesAndPermissionsResponse | null> => {
  if (!userId) {
    return null;
  }

  try {
    const response = await getApiV1UsersUserIdPermissions(Number(userId));

    if (!response) {
      return null;
    }

    return {
      role: response.role.filter((role): role is Role => Boolean(role)),
      permissions: response.permissions.filter(
        (permission): permission is Permission => Boolean(permission)
      ),
    };
  } catch (error) {
    console.error('Failed to fetch user roles and permissions:', error);

    return null;
  }
};
